module.exports = __webpack_public_path__ + "img/Halle_Leer 083.efe8f504.jpg";